import {
  hasInactiveSelections,
  hasNotLoadedSelections,
  invalidBalance,
  invalidMultipleSelectionsCount,
  invalidSingleSelectionsCount,
  invalidSystemSelectionsCount,
  stakeIsEmpty,
  stakeOutOfLimits,
  maxStakeLimitReached,
  maxStakeExceeded,
  invalidForecastSelectionsCount,
  invalidTricastSelectionsCount,
  invalidMinOdd,
  possibleWinOutOfLimits,
  placeBetDisabledRestriction,
  invalidFreeBet,
  incompleteBetBuilderCard,
  expressIdIncompatibility,
  betBuilderOddsLoading,
  betBuilderMissingTotalOdd,
  IBetBuilderValidationState,
} from "./validations";

import { composeOR } from "../strategy";
import { IClientConfig } from "src/client-config/config";
import { ISelection } from "src/constants/interfaces/bet";
import { IMainStore } from "src/stores/main";
import { IUpperDataStore } from "src/stores/upperData";

const basePlaceBetDisabled = composeOR(
  invalidBalance,
  stakeIsEmpty,
  stakeOutOfLimits,
  possibleWinOutOfLimits,
  invalidFreeBet,
  invalidSingleSelectionsCount,
  invalidMultipleSelectionsCount,
  invalidSystemSelectionsCount,
  invalidForecastSelectionsCount,
  invalidTricastSelectionsCount,
  invalidMinOdd,
  hasNotLoadedSelections,
  hasInactiveSelections,
  incompleteBetBuilderCard,
  expressIdIncompatibility,
  placeBetDisabledRestriction
);

// Place-bet wrapper that also folds in the bet-builder odds state. Kept as a
// thin function (not inside composeOR) because `bbState` lives in a separate
// Recoil atom and the base predicates don't take it — adding a 5th arg to
// every existing predicate would be churn for one feature.
export const placeBetDisabled = (
  config: IClientConfig,
  selections: ISelection[],
  mainState: IMainStore,
  upperDataState: IUpperDataStore,
  bbState?: IBetBuilderValidationState,
): boolean => (
  basePlaceBetDisabled(config, selections, mainState, upperDataState)
  || betBuilderOddsLoading(selections, bbState)
  || betBuilderMissingTotalOdd(selections, bbState)
);

export { maxStakeLimitReached, hasNotLoadedSelections, stakeOutOfLimits, hasInactiveSelections, maxStakeExceeded };

export const isPlaceBetAvailable = (config: IClientConfig, upperData: IUpperDataStore) => {
  const inViewMode = config.isViewMode && !upperData.userId;
  const bookingOnlyMode = config.enableBookingBet && config.bookingBetBalanceMaxLimit === 0 && upperData.balance === 0

  return !inViewMode && !bookingOnlyMode;
}
